// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import { Amplify } from 'aws-amplify';
import * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import awsconfig from './aws-exports';
import router from './router';
import { Emarf } from '@/plugins/emarf';
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n';

Amplify.configure(awsconfig);

Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(Emarf, { emarfEnv: process.env.EMARF_ENV });
Vue.use(i18n);

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['model-viewer'];

new Vue({
  router,
  vuetify
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js